module.exports = __webpack_public_path__ + "img/3.4f11deb3.jpg";